import React, { useEffect, useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { logisticsApi as api } from 'api/logistics';
import { DataTable, Notifications, TabPanel, UploadCSVAndReviewComponent } from 'shared';
import dayjs from 'utils/dayjsConfig';

function ShippingRateUploadCSV({ onSuccess }) {
    const columns = [
        { Header: 'Row', accessor: 'rowNumber' },
        { Header: 'Zip Code', accessor: 'zipCode' },
        { Header: 'Old Rate', accessor: 'prevValue' },
        { Header: 'Shipping Rate', accessor: 'shippingRate' },
        { Header: 'Errors', accessor: 'errors' },
        { Header: 'Warnings', accessor: 'warnings' },
    ];

    const confirm = async (key) => {
        const res = await api.confirmShippingRates(key);
        return res;
    };

    const upload = async (formData) => {
        const res = await api.uploadShippingRates(formData);
        return res;
    };

    const downloadTemplate = () => {
        const csvContent = 'data:text/csv;charset=utf-8,Zip Code,Shipping Rate,';
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'shipping_rate_template.csv');
        document.body.appendChild(link);

        link.click();
    };

    return (
        <div>
            <UploadCSVAndReviewComponent
                fileLabel="Shipping Rate File"
                title="Upload Shipping Rates"
                columns={columns}
                upload={upload}
                confirm={confirm}
                downloadTemplate={downloadTemplate}
                exportUploadResults
            />
        </div>
    );
}

function ViewCurrentRates() {
    const [rates, setRates] = useState([]);
    const [notification, setNotification] = useState({ text: '', level: '' });

    const getRates = async () => {
        const res = await api.getCurrentShippingRates();
        if (!res.status) {
            setNotification({ text: 'Failed to get current rates', level: 'error' });
            return;
        }

        setRates(
            res.data.rates.map((item) => {
                item.uploadDate = item.uploadTimestamp ? dayjs(item.uploadTimestamp.date).format('MM/DD/YYYY') : null;
                return item;
            }),
        );
    };

    useEffect(() => {
        getRates();
    }, []);

    const columns = [
        { Header: 'Zip Code', accessor: 'zipCode' },
        { Header: 'Shipping Rate', accessor: 'shippingRate' },
        { Header: 'Updated On', accessor: 'uploadDate' },
    ];

    return (
        <div>
            <Notifications options={notification} />

            <DataTable columns={columns} data={rates} csvExport />
        </div>
    );
}

function ShippingRateUpload() {
    const [selectedTab, setSelectedTab] = useState('0');

    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="Upload Shipping Rates" value="0" />
                <Tab label="View Shipping Rates" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ShippingRateUploadCSV />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <ViewCurrentRates />
            </TabPanel>
        </Paper>
    );
}

export { ShippingRateUpload };
